import './App.css';
import Header from './components/Header/Header';
import SelectTabs from './components/SelectTabs/SelectTabs';

function App() {
  return (
    <div className="App">
      <Header/>
      <SelectTabs/>
    </div>
  );
}

export default App;
